module.exports = new __parcel__URL__("MeyersMoviesAngular.fc78989f.png").toString();